import { render, staticRenderFns } from "./descriptions.vue?vue&type=template&id=19b43e4e&scoped=true"
import script from "./descriptions.vue?vue&type=script&lang=js"
export * from "./descriptions.vue?vue&type=script&lang=js"
import style0 from "./descriptions.vue?vue&type=style&index=0&id=19b43e4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b43e4e",
  null
  
)

export default component.exports